import { render, staticRenderFns } from "./prefrencefile-unit.vue?vue&type=template&id=6f143be8&scoped=true&"
import script from "./prefrencefile-unit.vue?vue&type=script&lang=tsx&"
export * from "./prefrencefile-unit.vue?vue&type=script&lang=tsx&"
import style0 from "./prefrencefile-unit.vue?vue&type=style&index=0&id=6f143be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f143be8",
  null
  
)

export default component.exports